import type { KeyboardEvent } from 'react';

const ZIP_REGEX = /^\d{5}$/;

const OPTIONAL_FIELDS = new Set<string>([
  'clientFinancialSecurityPreference',
  'clientIndependencePreference',
  'clientFamilyInvolvementPreference',
  'clientHasDifferentLtcZipCode',
]);

export const QUICK_EDIT_HOUSEHOLD_FIELDS = new Set<string>([
  'householdHouseholdSize',
  'householdLivingChildrenCount',
  'clientLivingSiblingsCount',
]);

export function isQuickEditFieldRequired(fieldName: string): boolean {
  return !OPTIONAL_FIELDS.has(fieldName);
}

export function getQuickEditFieldError(fieldName: string, value: string): string | null {
  if (isQuickEditFieldRequired(fieldName) && !value.trim()) {
    return 'This field is required.';
  }
  if (
    (fieldName === 'clientZipCode' || fieldName === 'clientLtcZipCode') &&
    value.length > 0 &&
    !ZIP_REGEX.test(value)
  ) {
    return 'Zip code must be exactly 5 digits.';
  }
  if (fieldName === 'clientWeightPounds' && value) {
    const num = Number(value);
    if (!Number.isInteger(num) || num < 50 || num > 700) {
      return 'Weight must be a whole number between 50 and 700 pounds.';
    }
  }
  if (fieldName === 'householdTotalAssetsValue' && value) {
    const num = Number(value);
    if (!Number.isFinite(num) || num < 0) {
      return 'Total assets must be zero or more.';
    }
  }
  if (fieldName === 'clientBirthDate' && value) {
    const date = new Date(value);
    const now = new Date();
    if (
      Number.isNaN(date.getTime()) ||
      date > now ||
      date.getUTCFullYear() < now.getUTCFullYear() - 120
    ) {
      return 'Enter a real date of birth.';
    }
  }
  if (QUICK_EDIT_HOUSEHOLD_FIELDS.has(fieldName) && value) {
    const num = Number(value);
    if (isNaN(num) || num < 0 || num > 50) {
      return 'Value must be between 0 and 50.';
    }
  }
  return null;
}

export const onlyDigitsKeyDown = (event: KeyboardEvent) => {
  if (
    !/[\d]/.test(event.key) &&
    !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key) &&
    !event.ctrlKey &&
    !event.metaKey
  ) {
    event.preventDefault();
  }
};
